import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { bonos, bonosTotalValue } from '../data/content';
export function BonosSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="bonos-title" data-id="element-15" data-mp="13ccu22lfbgda">
      <div className="mx-auto max-w-6xl" data-id="element-16" data-mp="ycqhzwhc0662">
        <SectionHeading eyebrow="🎁 Siempre incluidos" title="5 Bonos estratégicos" data-id="element-17" data-mp="tg9jq9gf4bf9" />

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-18" data-mp="oflrjkggdojg">
          {bonos.map((bono, index) => <motion.li key={bono.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-line bg-ink p-6" data-id="element-19" data-mp="kfux96rpwqa6" data-mpi={index}>
              <div className="flex items-center gap-2" data-id="element-20" data-mp="vu96lf2u8r1w">
                <span className="text-sm font-extrabold text-neutral-600" data-id="element-21" data-mp="vvslb18uiu1k">
                  {bono.id}
                </span>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-gold/10 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.15em] text-gold" data-id="element-22" data-mp="hx2lhdun6g9i">
                  <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-23" data-mp="1ak6yo63w20wd" />
                  Bono
                </span>
              </div>
              <h3 className="mt-3 text-xl font-extrabold leading-tight tracking-tight text-white" data-id="element-24" data-mp="10tlp5nmofbyo">
                {bono.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-neutral-400" data-id="element-25" data-mp="15rdt5g0lioj8">
                {bono.description}
              </p>
              <p className="mt-4 flex items-center gap-2 border-t border-line pt-4 text-sm" data-id="element-26" data-mp="1tg6kt0a6qa81">
                <span className="text-neutral-600 line-through" data-id="element-27" data-mp="1yb2nqvgymhzx">
                  {bono.value}
                </span>
                <span className="font-extrabold uppercase tracking-wide text-gold" data-id="element-28" data-mp="235vjb5mg2au6">
                  Gratis
                </span>
              </p>
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl rounded-3xl border border-gold/30 bg-gold/[0.06] px-6 py-6 text-center text-lg font-extrabold tracking-tight text-white sm:text-2xl" data-id="element-29" data-mp="1t7pkwxzujmu2">
          Valor total bonos{' '}
          <span className="line-through opacity-50" data-id="element-30" data-mp="1kfnl91xlqaku">{bonosTotalValue}</span> →{' '}
          <span className="text-gold" data-id="element-31" data-mp="1fganvn93tl40">GRATIS con tu MegaPack</span>
        </p>
      </div>
    </section>;
}